import { render, staticRenderFns } from "./WarehouseV3.vue?vue&type=template&id=106215dd"
import script from "./WarehouseV3.vue?vue&type=script&lang=js"
export * from "./WarehouseV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports